import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {HeadersInterceptor} from './headers.interceptor';
import {SecurityInterceptor} from './security.interceptor';
import {NetworkInterceptor} from './network.interceptor';

@NgModule({
  imports: [],
  declarations: [],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: SecurityInterceptor,
    multi: true,
  }, {
    provide: HTTP_INTERCEPTORS,
    useClass: NetworkInterceptor,
    multi: true,
  }, {
    provide: HTTP_INTERCEPTORS,
    useClass: HeadersInterceptor,
    multi: true,
  }]
})
export class InterceptorsModule {
}

